require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-who-cares-about-social-care.json") })
        }
      }, "path---blog-who-cares-about-social-care");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-who-cares-about-social-care!./.cache/json/blog-who-cares-about-social-care.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---blog-who-cares-about-social-care!./.cache/json/blog-who-cares-about-social-care.json
// module chunks = 231608221292675